import axios from "axios";

/*
 * Kept beside the landing page rather than in api/index.ts: the whole landing
 * page is temporary and this way removing it does not touch the shared client.
 *
 * The form posts twice. The first call carries the email alone; the second,
 * sent only if the visitor answers the contest question, repeats the email
 * with `answer`. The backend upserts by email, so the repeat is not an error.
 */
export interface ContestEntry {
  email: string;
  answer?: string;
  // Invisible field that only bots fill in; the backend discards those entries.
  honeypot?: string;
}

export const submitContestEntry = async (entry: ContestEntry): Promise<void> => {
  await axios.post(
    "/api/landing/contest",
    { ...entry, consent: true },
    { headers: { "X-Requested-With": "XMLHttpRequest" } },
  );
};
